import classNames from 'classnames';
import { camelCase } from 'lodash-es';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import * as IBooks from '../../../../interfaces/merchants/resources/books';
import BooksLabel from '../../common/labels/BooksLabel';
import BooksCheckInput, { InputType } from './BooksCheckInput';

import css from './BooksPaymentItem.module.scss';

interface Props extends React.HTMLProps<{}> {
  onChange: (e: React.ChangeEvent) => void;
  checked: boolean;
  payment: IBooks.PaymentMethod;
}
const BooksPaymentItem = ({
  className,
  intl,
  onChange,
  checked,
  payment,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksPaymentItem, className);
  const errors = payment.disabled_reasons
    ? payment.disabled_reasons.filter(
        r =>
          r !== IBooks.DisabledReason.NoProducts &&
          r !== IBooks.DisabledReason.LimitExceeded,
      )
    : [];
  if (payment.method === 'credit_card') {
    return (
      <li className={classes}>
        <BooksCheckInput
          type={InputType.Radio}
          name="payment"
          checked={checked}
          value={payment.method}
          labelClassName={css.BooksPaymentItem__Inner}
          onChange={onChange}
          disabled={!payment.available}
        >
          <span>
            {intl.formatMessage({ id: 'books.paymentMethod.creditCard' })}
            <BooksLabel
              label={intl.formatMessage({
                id: 'books.paymentMethod.prepayment',
              })}
              className={css.BooksPaymentItem__Label}
            />
          </span>
          <span className={css.BooksPaymentItem__Price}>
            <FormattedMessage
              id="books.paymentMethod.price"
              values={{ price: payment.price }}
            />
          </span>
        </BooksCheckInput>
      </li>
    );
  } else if (
    payment.method === 'onsite' ||
    payment.method === 'bank_transfer'
  ) {
    return (
      <li className={classes}>
        <BooksCheckInput
          type={InputType.Radio}
          name="payment"
          checked={checked}
          value={payment.method}
          labelClassName={css.BooksPaymentItem__Inner}
          onChange={onChange}
          disabled={!payment.available}
        >
          <span>
            {intl.formatMessage({
              id: `books.paymentMethod.${camelCase(payment.method)}`,
            })}
          </span>
          <span className={css.BooksPaymentItem__Price}>
            <FormattedMessage
              id="books.paymentMethod.price"
              values={{ price: payment.price }}
            />
          </span>
        </BooksCheckInput>
      </li>
    );
  } else if (payment.method === 'subscription') {
    return (
      <li className={classes}>
        <BooksCheckInput
          type={InputType.Radio}
          name="payment"
          checked={checked}
          value={payment.method}
          labelClassName={css.BooksPaymentItem__Inner}
          onChange={onChange}
          disabled={errors.length > 0}
        >
          {errors.length > 0 ? (
            <span className={css.BooksPaymentItem__Disabled}>
              {`${intl.formatMessage({
                id: 'books.paymentMethod.subscription',
              })} (${intl.formatMessage({
                id: `books.paymentMethod.${errors[0]}`,
              })})`}
            </span>
          ) : (
            <span>
              {intl.formatMessage({ id: 'books.paymentMethod.subscription' })}
            </span>
          )}
        </BooksCheckInput>
      </li>
    );
    //           {/* Use i18n */}
    //           上級クラス回数券
    //           <span className={css.BooksPaymentItem__Description}>
    //             {intl.formatMessage({
    //               id: 'books.paymentMethod.expirationDate',
    //             })}
    //             <FormattedDate
    //               value={new Date(payment.period.from)}
    //               year="numeric"
    //               month="short"
    //               day="numeric"
    //             />
    //             〜
    //             <FormattedDate
    //               value={new Date(payment.period.to)}
    //               year="numeric"
    //               month="short"
    //               day="numeric"
    //             />
    //           </span>
    //         </span>
    //         <span className={css.BooksPaymentItem__Tickets}>
    //           {intl.formatMessage({ id: 'books.paymentMethod.rest' })}
    //           <span>{payment.rest}</span>
    //         </span>
    //       </BooksCheckInput>
    //     </li>
  } else if (payment.method === 'ticket') {
    return (
      <li className={classes}>
        <BooksCheckInput
          type={InputType.Radio}
          name="payment"
          checked={checked}
          value={payment.method}
          labelClassName={css.BooksPaymentItem__Inner}
          onChange={onChange}
          disabled={errors.length > 0}
        >
          {errors.length > 0 ? (
            <span className={css.BooksPaymentItem__Disabled}>
              {`${intl.formatMessage({
                id: 'books.paymentMethod.ticket',
              })} (${intl.formatMessage({
                id: `books.paymentMethod.${errors[0]}`,
              })})`}
            </span>
          ) : (
            <span>
              {intl.formatMessage({ id: 'books.paymentMethod.ticket' })}
            </span>
          )}
        </BooksCheckInput>
      </li>
    );
    //         <span>
    //           {/* Use i18n */}
    //           月会員 月謝
    //           <span className={css.BooksPaymentItem__Description}>
    //             {intl.formatMessage({
    //               id: 'books.paymentMethod.expirationDate',
    //             })}
    //             <FormattedDate
    //               value={new Date(payment.period.from)}
    //               year="numeric"
    //               month="short"
    //               day="numeric"
    //             />
    //             〜
    //             <FormattedDate
    //               value={new Date(payment.period.to)}
    //               year="numeric"
    //               month="short"
    //               day="numeric"
    //             />
    //           </span>
    //         </span>
    //       </BooksCheckInput>
    //     </li>
  }
  return null;
};

export default injectIntl(BooksPaymentItem);
